import { render, staticRenderFns } from "./redeemCode.vue?vue&type=template&id=a8070f62&scoped=true&"
import script from "./redeemCode.vue?vue&type=script&lang=js&"
export * from "./redeemCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8070f62",
  null
  
)

export default component.exports